export enum PermissionEnum {
  HasWriteAccess = 1, // Can Create/Edit/Delete records in the allowed APIs
  CanViewBankAccounts = 2,
  CanEditBankAccounts = 3,
  CanViewPayments = 4,
  CanCreatePayments = 5,
  RiskOrFinanceTeam = 7,
  CheckFullKybAdministrator = 8,
  SuperAdmin = 1000, // Full access
}

export const permissionNames = {
  [PermissionEnum.HasWriteAccess]: 'Has Write Access',
  [PermissionEnum.CanViewBankAccounts]: 'Can View Bank Accounts',
  [PermissionEnum.CanEditBankAccounts]: 'Can Edit Bank Accounts',
  [PermissionEnum.CanViewPayments]: 'Can View Payments',
  [PermissionEnum.CanCreatePayments]: 'Can Create Payments',
  [PermissionEnum.RiskOrFinanceTeam]: 'Risk Or Finance Team',
  [PermissionEnum.CheckFullKybAdministrator]: 'Check Full Kyb Administrator',
  [PermissionEnum.SuperAdmin]: 'Super Admin',
};
